import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { getSelectedStore } from 'x/redux/selectors'

import { TouchableOpacity, View } from 'react-native'

import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as util from 'x/utils/util'
import * as api from 'x/utils/api'
import { COLORS, S } from 'x/config/styles'
import { ICrmChannelCreateDeepBlokViewProps, ICrmChannelCreateDeepBlokViewState, IXSegmentOption, ICrmChannel } from 'x/types'

// import BackIcon from 'xui/components/BackIcon'
import VStack from 'xui/components/VStack'
import XText from 'xui/components/XText'
import XContent from 'xui/components/XContent'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import * as NavActions from 'x/utils/navigation'
import HStack from 'xui/components/HStack'
import XImage from 'xui/components/XImage'
import XIconButton from 'xui/components/XIconButton'
import XIcon from 'xui/components/XIcon'
import CrmLogo from 'xui/components/CrmLogo'
import XCard from 'xui/components/XCard'
import XSpinner from 'xui/components/XSpinner'
import XInput from 'xui/components/XInput'

class CrmChannelCreateDeepBlokView extends React.Component<ICrmChannelCreateDeepBlokViewProps, ICrmChannelCreateDeepBlokViewState> {
  static displayName = 'CrmChannelCreateDeepBlokView'

  _inProcess?: boolean

  constructor(props: ICrmChannelCreateDeepBlokViewProps) {
    super(props)
    this.state = {
      isInitialized: false,
      isRefreshing: false,
      isSubmitting: false,

      name: '',
      brand_code: '',
      client_code: '',
      hash_key: '',
      key_code: '',
      system_brand_name: '',
    }
  }

  async componentDidMount() {
    await this._initializeView()
  }

  _initializeView = async () => {
    await util.setStatePromise(this, { isInitialized: false, products: [], selectedReason: null })
    // Init activeStatesMap
    const newState: Partial<ICrmChannelCreateDeepBlokViewState> = {}
    // get ready to render
    newState.isInitialized = true

    await util.setStatePromise(this, newState)
  }

  _createCrmChannel = async () => {
    if (this._inProcess) {
      return
    }
    this._inProcess = true
    await util.setStatePromise(this, { isSubmitting: true })

    await this._createCrmChannelWithDeepblok()

    await util.setStatePromise(this, { isSubmitting: false })
    this._inProcess = false
  }

  _createCrmChannelWithDeepblok = async () => {
    const storeId = util.getNavParam(this.props, 'store_id')
    const { name, client_code, key_code, hash_key, brand_code, system_brand_name } = this.state

    try {
      const res = await api.createCrmChannelWithDeepblok({
        store_id: storeId,
        name,
        client_code: client_code || '',
        key_code: key_code || '',
        hash_key: hash_key || '',
        brand_code: brand_code || '',
        system_brand_name: system_brand_name || '',
      })

      if (res && res.crm_channel) {
        await util.setStatePromise(this, { crmChannelDetail: res.crm_channel, editingName: res.crm_channel.name })

        const onCreatedSuccess = util.getNavParam(this.props, 'onCreatedSuccess')
        if (onCreatedSuccess) {
          onCreatedSuccess(res.crm_channel)
        }

        this._goBack()
      }
    } catch (err) {
      console.log('CrmChannelCreateDeepBlokView::_fetchCrmChannelDetail:: err => ', err)
    }
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _renderCustomHeader = () => {
    return (
      <XCustomHeader
        title={p.op.t('crm.channelCreateView.deepblokTitle')}
        headerLeftProps={{ backIcon: true, onPressItem: this._goBack }}
      />
    )
  }

  _renderNameInput = () => {
    const { name, isSubmitting } = this.state

    return (
      <HStack w='full' space='1.5' alignItems='center'>
        <XText w='100px' variant='inactive'>
          {p.op.t('crm.channelCreateView.name')}
        </XText>

        <XInput
          flex={1}
          disabled={isSubmitting}
          isDisabled={isSubmitting}
          placeholder={p.op.t('crm.channelCreateView.name')}
          value={name}
          onChangeText={(text) => this.setState({ name: text })}
        />
      </HStack>
    )
  }

  // _renderCrmSystemSelector = () => {
  //   const { crm_system_id } = this.state

  //   return (
  //     <VStack w='full'>
  //       <XText variant='inactive' t={'crm.channelCreateView.chooseCrmSystem'} />

  //       <HStack alignItems='center' space='2'>
  //         <XRadio checked={crm_system_id === 1} onPress={() => this.setState({ crm_system_id: 1 })} />
  //         <HStack alignItems='center' space='1'>
  //           <CrmLogo crmSystemId={1} width={22} height={22} />
  //           <XText t={`crm.crm_system_name_by_id.1`} />
  //         </HStack>
  //       </HStack>
  //     </VStack>
  //   )
  // }

  _renderDeepblokConfigInputs = () => {
    const { brand_code, client_code, hash_key, key_code, system_brand_name, isSubmitting } = this.state

    return (
      <VStack w='full' pt='2' space='2'>
        <XText variant='inactive'>{p.op.t('crm.channelCreateView.deepblokConfigTitle')}</XText>
        {/* <XText variant='inactive' fontSize='xs'>
          {p.op.t('crm.channelCreateView.deepblokConfigSubTitle')}
        </XText> */}

        <HStack w='full' alignItems='center' space='1'>
          <XText w='150px' variant='inactive' t={'crm.channelCreateView.deepblok.client_code'} />

          <XInput
            flex={1}
            disabled={isSubmitting}
            isDisabled={isSubmitting}
            placeholder='Client Code'
            value={client_code}
            onChangeText={(text) => this.setState({ client_code: text })}
          />
        </HStack>

        <HStack w='full' alignItems='center' space='1'>
          <XText w='150px' variant='inactive' t={'crm.channelCreateView.deepblok.key_code'} />

          <XInput
            flex={1}
            disabled={isSubmitting}
            isDisabled={isSubmitting}
            placeholder='Key Code'
            value={key_code}
            onChangeText={(text) => this.setState({ key_code: text })}
          />
        </HStack>

        <HStack w='full' space='1'>
          <HStack w='150px' pt='2'>
            <XText w='150px' variant='inactive' t={'crm.channelCreateView.deepblok.hash_key'} />
          </HStack>

          <XInput
            flex={1}
            disabled={isSubmitting}
            isDisabled={isSubmitting}
            placeholder='Hash Key'
            multiline
            minH='120px'
            value={hash_key}
            onChangeText={(text) => this.setState({ hash_key: text })}
          />
        </HStack>

        <HStack w='full' alignItems='center' space='1'>
          <XText w='150px' variant='inactive' t={'crm.channelCreateView.deepblok.brand_code'} />

          <XInput
            flex={1}
            disabled={isSubmitting}
            isDisabled={isSubmitting}
            placeholder='Brand Code'
            value={brand_code}
            onChangeText={(text) => this.setState({ brand_code: text })}
          />
        </HStack>

        <HStack w='full' alignItems='center' space='1'>
          <XText w='150px' variant='inactive' t={'crm.channelCreateView.deepblok.system_brand_name'} />

          <XInput
            flex={1}
            disabled={isSubmitting}
            isDisabled={isSubmitting}
            placeholder='System Brand Name'
            value={system_brand_name}
            onChangeText={(text) => this.setState({ system_brand_name: text })}
          />
        </HStack>
      </VStack>
    )
  }

  _isFormValid = () => {
    const { name, brand_code, client_code, hash_key, key_code, system_brand_name } = this.state

    if (!name.trim()) {
      return false
    }

    // Deepblok
    if (!brand_code?.trim() || !client_code?.trim() || !hash_key?.trim() || !key_code?.trim() || !system_brand_name?.trim()) {
      return false
    }

    return true
  }

  _renderCreateButton = () => {
    const { isSubmitting } = this.state
    const isFormValid = this._isFormValid()
    const isDisabled = isSubmitting || !isFormValid

    return (
      <HStack w='full' p='2' bg='white'>
        <TouchableOpacity disabled={isDisabled} style={{ flex: 1 }} onPress={this._createCrmChannel}>
          <HStack
            w='full'
            h='44px'
            borderWidth='1'
            borderColor={isDisabled ? 'gray.400' : 'primary.500'}
            borderRadius='50px'
            bg={isDisabled ? 'gray.200' : 'primary.500'}
            space='2'
            alignItems='center'
            justifyContent='center'
          >
            {isSubmitting ? <XSpinner /> : null}

            <XText variant={isDisabled ? 'active' : 'activeDark'}>
              {isFormValid ? p.op.t('crm.channelCreateView.createBtn') : p.op.t('crm.channelCreateView.invalidForm')}
            </XText>
          </HStack>
        </TouchableOpacity>
      </HStack>
    )
  }

  _renderContent = () => {
    const { isInitialized, isRefreshing } = this.state
    if (!isInitialized) {
      return null
    }

    if (isRefreshing) {
      return (
        <VStack w='full' p='2'>
          <XSpinner />
        </VStack>
      )
    }

    return (
      <VStack w='full' px='6' py='4' bg='white' space='2'>
        {this._renderNameInput()}
        {/* {this._renderCrmSystemSelector()} */}
        {this._renderDeepblokConfigInputs()}
      </VStack>
    )
  }

  render() {
    return (
      <XContainer>
        {this._renderCustomHeader()}
        <XContent>{this._renderContent()}</XContent>
        {this._renderCreateButton()}
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(CrmChannelCreateDeepBlokView)
